import styled from "styled-components";

export const BillboardPageContainer = styled.div`
  height: 100%;
  margin: 0 auto;
  padding: 2rem;
  width: 100%;

  .billboard-header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1.5rem;

    .billboard-header-buttons {
      display: flex;
      gap: 1rem;
    }

    a.go-to-billboard-button {
      background: ${({ theme }) =>
        theme.controlPanel.billboardBackgroundListItems} !important;
    }

    .new-session-button {
      background: #0072e5e2;
      color: #f2f2f2;
      &:hover {
        background: #0072e5;
      }
      svg * {
        stroke: #f2f2f2;
      }
    }

    h1 {
      align-items: center;
      color: ${({ theme }) => theme.groups.primaryText};
      display: flex;
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: max(1.2vw, 1.5rem);
      line-height: 150%;
      margin: 0;
    }

    button,
    a {
      cursor: pointer;
      align-items: center;
      border-radius: 0.25rem;
      border: none;
      color: ${({ theme }) => theme.groups.secondaryText};
      display: flex;
      flex-direction: row;
      font-family: "Inter";
      font-style: normal;
      font-weight: 600;
      font-size: max(0.6vw, 0.875rem);
      gap: 0.5rem;
      justify-content: center;
      padding: 0.5rem 1rem;
      line-height: 150%;
      transition: all 100ms ease-in-out;
    }
  }

  @media (max-width: 600px) {
    .billboard-header {
      display: flex;
      flex-direction: column;
      gap: 1rem;

      .billboard-header-buttons {
        button,
        a {
          width: 100%;
        }
      }
    }
  }
`;

export const LoadingMessageContainer = styled.div`
  color: ${({ theme }) => theme.groups.primaryText};

  text-align: center;
  margin-top: 5rem;
  padding: 0 1rem;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1.5rem;
`;
